function variantschange_image(variantfmid, productdata) {
  let medialist = (productdata && productdata["media"]) ? productdata["media"] : [];
  let variantslist = (productdata && productdata["variants"]) ? productdata["variants"] : [];
  let mediaidlist = [];

  variantslist.forEach(v => {

    const fm = v && v["featured_media"];
    const fmId = fm && fm["id"] ? fm["id"] : null;


    if (!fmId) return;


    if (fmId !== variantfmid) {
      if (!mediaidlist.includes(fmId)) mediaidlist.push(fmId);
    }
  });

  let mediaStartFlag = false;

  $(".Product__SlideshowNavScroller .Product__SlideshowNavImage").remove();
  $(".Product__SlideshowMobileNav .flickity-page-dots .dot").remove();

  let mobiecount = 0;

  for (let i = 0; i < medialist.length; i++) {
    let selectFlag = false;
    const element = medialist[i];

    if (!element || !element["id"]) continue;

    if (element["id"] == variantfmid) {
      mediaStartFlag = true;
      selectFlag = true;
    }

    if (mediaStartFlag) {
      if (mediaidlist.includes(element["id"])) {
        mediaStartFlag = false;
      }
    }

    if (mediaStartFlag) {
      const isselected = selectFlag ? "is-selected" : "";
      const ismobieselected = mobiecount === 0 ? "is-selected" : "";

      let imgSrc = element["src"] || "";
      let aspect = element["aspect_ratio"] || 1;
      let altText = element["alt"] ? escape(element["alt"]) : "";

      let hrefurl = imgSrc ? (imgSrc + "&width=1024") : "";
      let imgurl = imgSrc ? (imgSrc + "&width=160") : "";

      let imghtml = `<div data-media-id="${element["id"]}" class="Product__SlideshowNavImage AspectRatio ${isselected}" style="--aspect-ratio: ${aspect};cursor: pointer;">
                        <img src="${imgurl}" alt="${altText}">
                      </div>`;

      let mobiehtml = `<button type="button" aria-label="Show image ${element["position"] || (mobiecount + 1)}" class="dot ${ismobieselected}" data-index="${i}"></button>`;

      $(".Product__SlideshowNavScroller").append(imghtml);
      $(".Product__SlideshowMobileNav .flickity-page-dots").append(mobiehtml);

      mobiecount++;
    }
  }
}
